/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'clumsy',
    quality: 0,
    dexterity: -2,
    dodgeChance: -2
}